import styled from 'styled-components';
import { ReactComponent as CoinIcon } from 'src/assets/icons/bonus-game/coin.svg';
import { ReactComponent as EditTitleIcon } from 'src/assets/icons/bonus-game/edit-title.svg';
import { HorizontalView, VerticalView } from 'src/components/FlexViews';
import { useNavigate } from 'react-router-dom';
import { useUserContext } from 'src/pages/BonusGame/contexts/UserContext';

const ProfileWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0 15px;
`;

const TreeNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
`;

const TreeName = styled.h1`
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 150px;
`;

const EditableInput = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid #aade16;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  outline: none;
  text-align: center;
  width: 200px;
`;

const BalanceWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  margin-top: 5px;
`;

const BalanceLabel = styled.span`
  color: #7e8a93;
  font-size: 14px;
`;

const BalanceAmount = styled.span`
  color: #ffffff;
  font-size: 14px;
`;

const BonusTreeName = () => {
  const { gameStat } = useUserContext();
  const navigate = useNavigate();

  return (
    <TreeNameWrapper onClick={() => navigate('/bonus-game/edit-tree')}>
      <HorizontalView style={{ gap: '8px' }}>
        <TreeName>{gameStat.bonusTreeName}</TreeName>
        <EditTitleIcon />
      </HorizontalView>
    </TreeNameWrapper>
  );
};

interface ProfileProps {
  balance: number;
}

export const Profile = ({ balance }: ProfileProps) => {
  const formattedBalance = balance.toLocaleString('fr-FR');

  return (
    <ProfileWrapper>
      <BonusTreeName />

      <BalanceWrapper>
        <BalanceLabel>Total coins</BalanceLabel>
        <CoinIcon width={14} height={14} />
        <BalanceAmount>{formattedBalance}</BalanceAmount>
      </BalanceWrapper>
    </ProfileWrapper>
  );
};
